import { useAuditSummary } from '@/hook/useAuditSummary';
import React from 'react';
import './audit-kpis.css';

export function AuditKpis() {
	const data = useAuditSummary();
	if (!data) return null;

	return (
		<div className="audit-kpis-container">
			<Tile label="Total" value={data?.totals?.total} />
			<Tile label="Successes" value={data?.totals?.successes} />
			<Tile label="Errors" value={data?.totals?.errors} />
		</div>
	);
}

function Tile({ label, value }) {
	return (
		<div className="audit-tile">
			<div className="tile-label">{label}</div>
			<div className="tile-value">{value ?? 0}</div>
		</div>
	);
}
